import type { RateLimit } from '../../utils';

export enum AddTripStatus {
  SUCCESS,
  RATE_LIMIT,
  NAME_DOES_NOT_MATCH,
  BAD_BOOKING_CODE,
  BOOKING_NOT_FOUND,
  BOOKING_IN_THE_PAST,
  ALREADY_ADDED,
  ALREADY_ADDED_TO_OTHER_ACCOUNT,
  UNEXPECTED_STRING_RESPONSE,
  GENERAL_ERROR,
}

export type AddTripResult = {
  status: AddTripStatus;
  rateLimit: RateLimit;
  maskedEmail?: string;
};

export const ADD_TRIPS_RATE_LIMIT_NAME = 'addTrips';
